// CRA inlines REACT_APP_* at build time.

export const dotnetBackendApiUrl = process.env.REACT_APP_API_URL_DOTNET_BACKEND;

export const dotnetBackendRevealBaseUrl = process.env.REACT_APP_REVEAL_BASE_URL_DOTNET_BACKEND;

const dotnetBackendRevealDataUrl = process.env.REACT_APP_REVEAL_DATA_URL_DOTNET_BACKEND;

export const dotnetBackendRevealDashboardsUrl = `${dotnetBackendRevealDataUrl}dashboards`;

export const dotnetBackendRevealCustomdashboardsUrl = `${dotnetBackendRevealDataUrl}customdashboards`;

export function dotnetBackendRevealDeletedashboardUrl(dashboardId: string | number): string {
  return `${dotnetBackendRevealDataUrl}deletedashboard/${dashboardId}`;
}
